/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const modulesFormDataInputOptionDataSchema = z.object({
	id: z.string().nullable(),
	label: z.string(),
	position: z.number(),
	isDisqualifying: z.boolean().nullable().default(false),
	scoreValue: z.number().nullable(),
	consentType: z.string().nullable(),
})

export type ModulesFormDataInputOptionDataSchema = z.infer<typeof modulesFormDataInputOptionDataSchema>
